<template>
  <div class="m-content">
    <div v-if="firstTime">
      <img class="home-img" :src="currentSplashSrc" @click="enterActivity">
    </div>
    <div v-else>
      <div v-if="activitiesHome">
        <div class="first-bg">
          <img :src='currentFaceSrc'>
        </div>
        <div class="text-info">
          <p class="text-left" :class="{ active: isActive }">{{shengyaUser.studentName + '&nbsp;&nbsp;' +shengyaUser.studentMajor}}</p>
          <button class="info" @click="handleEnterInfo">&nbsp;&nbsp;个人资料</button>
          <button class="info color" @click="outLogin = true" v-if="isShowExit">退出</button>
          <button class="info" v-if="jsonSetting.jsShow==1" @click="handleEnterActivityDescription">&nbsp;&nbsp;&nbsp;&nbsp;活动介绍</button>
          <button class="info" v-if="jsonSetting.jsShow==1" @click="handleEnterOrganiserIntroduction">主办方介绍</button>
        </div>
        <!-- 专家咨询 在线支持 -->
        <div class="area" v-if="isShowConsult && isShowSupport">
          <div class="area-content">
            <div class="left-consult " :class="{invalid: !consult}" @click="handleEnterConsult" v-if="isShowConsult">
              <div class="img-area"><img :src="iconImg('icon-06')" /></div>
              <div class="text-area">
                <h4 class="text-name">专家咨询</h4>
              </div>
              <div v-if="!consult" class="disabled">
                 <i class="iconfont icon-lock" title="禁用"></i>
              </div>
            </div>
            <div class="right-side " :class="{invalid: !dayi}" @click="handleEnterChat" v-if="isShowSupport">
              <div class="img-area">
                <!-- <img src="../images/icon/icon-02.gif"> -->
                 <span class="icon-box"><i class="iconfont icon-ketangdayi" title="答疑"></i></span>
              </div>
              <div class="text-area">
                <h4 class="text-name">在线支持</h4>
              </div>
              <div v-if="!dayi" class="disabled">
                 <i class="iconfont icon-lock" title="禁用"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-content">
            <div class="left-side" :class="{invalid: !openAward}" @click="handleEnterAward">
              <div class="img-area">
              <img :src="iconImg('icon-01')"/>
              </div>
              <div class="text-area">
                <h4 class="text-name">抽奖</h4>
              </div>
              <div v-if="!openAward" class="disabled">
                 <i class="iconfont icon-lock" title="禁用"></i>
              </div>
            </div>
            <div class="right-side"  @click="handleEnterReport">
              <div class="img-area"><img :src="iconImg('icon-04')"/></div>
              <div class="text-area">
                <h4 class="text-name">个人报告</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="area-content">
          <div class="left-side left-module">
            <h4 class="area-title">区域一：生涯成熟度</h4>
            <AreaBox :missionId=1 :missionName="missionNames[0]" @playMission="handlePlayMission" :finish="arrCosPlay[0]" :invalid="checkMissionInvalid(1)" ></AreaBox>
            <AreaBox :missionId=2 :missionName="missionNames[1]" @playMission="handlePlayMission" :finish="arrCosPlay[1]" :invalid="checkMissionInvalid(2)" ></AreaBox>
            <AreaBox :missionId=3 :missionName="missionNames[2]" @playMission="handlePlayMission" :finish="arrCosPlay[2]" :invalid="checkMissionInvalid(3)" ></AreaBox>
          </div>
          <div class="left-side left-module">
            <h4 class="area-title">区域二：职业匹配度</h4>
            <AreaBox :missionId=4 :missionName="missionNames[3]" @playMission="handlePlayMission" :finish="arrCosPlay[3]" :invalid="checkMissionInvalid(4)" ></AreaBox>
            <AreaBox :missionId=5 :missionName="missionNames[4]" @playMission="handlePlayMission" :finish="arrCosPlay[4]" :invalid="checkMissionInvalid(5)" ></AreaBox>
            <AreaBox :missionId=6 :missionName="missionNames[5]" @playMission="handlePlayMission" :finish="arrCosPlay[5]" :invalid="checkMissionInvalid(6)" ></AreaBox>
          </div>
        </div>
        <div class="area-content">
          <div class="left-side left-module">
            <h4 class="area-title">区域三：职业胜任力</h4>
            <AreaBox :missionId=7 :missionName="missionNames[6]" @playMission="handlePlayMission" :finish="arrCosPlay[6]" :invalid="checkMissionInvalid(7)" ></AreaBox>
            <AreaBox :missionId=8 :missionName="missionNames[7]" @playMission="handlePlayMission" :finish="arrCosPlay[7]" :invalid="checkMissionInvalid(8)" ></AreaBox>
            <AreaBox :missionId=9 :missionName="missionNames[8]" @playMission="handlePlayMission" :finish="arrCosPlay[8]" :invalid="checkMissionInvalid(9)" ></AreaBox>
          </div>
          <div class="left-side left-module">
            <h4 class="area-title">区域四：生涯决策力</h4>
            <AreaBox :missionId=10 :missionName="missionNames[9]" @playMission="handlePlayMission" :finish="arrCosPlay[9]" :invalid="checkMissionInvalid(10)" ></AreaBox>
            <AreaBox :missionId=11 :missionName="missionNames[10]" @playMission="handlePlayMission" :finish="arrCosPlay[10]" :invalid="checkMissionInvalid(11)" ></AreaBox>
            <AreaBox :missionId=12 :missionName="missionNames[11]" @playMission="handlePlayMission" :finish="arrCosPlay[11]" :invalid="checkMissionInvalid(12)" ></AreaBox>
          </div>
        </div>
        <div class="area-content">
          <div class="left-side left-module">
            <h4 class="area-title">区域五：生涯困难诊断</h4>
            <AreaBox :missionId=13 :missionName="missionNames[12]"  @playMission="handlePlayMission" :finish="arrCosPlay[12]" :invalid="checkMissionInvalid(13)" ></AreaBox>
          </div>
          <div class="left-side left-module">
            <h4 class="area-title">其他</h4>
            <div class="area-box" @click="handleEnterTreasure">
              <div class="img-area"><img :src="iconImg('icon-treasure')" /></div>
              <div class="text-area">
                <h4 >多宝库</h4>
              </div>
            </div>
          </div>
        </div>
        <div class="bottom">
          <img :src="logoImg">
          <span>仁能达教育©版权所有</span>
        </div>
      </div>
      <!-- 校领导讲话 -->
      <div v-if="enterVideo" >
        <VideoPlay
          :videoUrl="currentVideoSrc"
          :videoCover="currentVideoFaceSrc"
          :width="videoWidth"
          :height="videoHeight"
          :autoplay="false"
          :loop="false"
          :muted="false"
          preload="auto"
          :playWidth="96"
          zoom="none"/>
        <el-button plain style="position:absolute;top:10px;right:10px;" @click="ignoreVideo">跳过</el-button>
      </div>
      <!-- 活动详情（进入闯关） -->
      <div v-if="enterMission">
        <Mission :id="enterMissionId" @back-activities="handleBackActivities"/>
      </div>
      <!-- 答疑 -->
      <div v-if="enterChat" >
        <Player @backMission="handleBackActivities"/>
      </div>
      <!-- 修改资料 -->
      <div v-if="enterInfo">
        <Info @return-activities="handleBackActivities" @finish-user="finishUser"/>
      </div>
      <!-- 咨询 -->
      <div v-if="enterConsult">
        <Consult @back-activities="handleBackActivities"/>
      </div>
      <!-- 多宝库 -->
      <div v-if="enterTreasure">
        <Treasure @back-activities="handleBackActivities"/>
      </div>
      <!-- 抽奖 -->
      <div v-if="enterAward">
        <Feedback v-if="this.shengyaUser.arrCosAward[0]=='0'" :id="96" ></Feedback>
        <Award v-else :id="96" ></Award>
      </div>
      <div v-if="enterReport">
        <PersonalReport  @back-activities="handleBackActivities" />
      </div>
      <div v-if="enterActivityDescription">
         <ActivityDescription @return-activities="handleBackActivities"/>
      </div>
      <div v-if="enterOrganiserIntroduction">
         <OrganiserIntroduction @return-activities="handleBackActivities"/>
      </div>
      <el-dialog
        :visible.sync="cannotplay"
        width="300px"
        class="text-center"
        :show-close="false"
      >
        <div style="margin-top: -20px">{{this.cannotplayInfo}}</div>
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            @click="cannotplay = false"
            style="width: 100%"
            >关 闭</el-button
          >
        </span>
      </el-dialog>
      <!-- 退出 -->
      <el-dialog
        :visible.sync="outLogin"
        width="300px"
        class="text-center"
        :show-close="false"
      >
        <div style="margin-top: -20px; text-align: center">确定要退出吗？</div>
        <span slot="footer" class="footerBtn">
          <el-button
            round
            @click="outLogin = false"
            style="width: 100%"
            >取 消</el-button
          >
          <el-button
            round
            type="primary"
            @click="sureOutLogin"
            style="width: 100%"
            >确 定</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import AreaBox from '@/components/mission/areaBox.vue'
import Mission from '@/page/mission'
import Player from '@/page/player/PagePlayerMobile'
import Info from '@/page/Info'
import Consult from '@/page/consult'
import Treasure from '@/page/Treasure'
import Award from '@/page/Award'
import Feedback from '@/page/Feedback'
import PersonalReport from '@/page/PersonalReport'
import ActivityDescription from '@/page/ActivityDescription'
import OrganiserIntroduction from '@/page/OrganiserIntroduction'
import VideoPlay from '@/components/VideoPlay'
import setWechatTitle from '@/utils/setWechatTitle.js'
import moment from 'moment'
import md5 from 'js-md5'
export default {
  name: 'Activities',
  components: {
    Player,
		AreaBox,
    Mission,
    Info,
    Consult,
    Treasure,
    Award,
    Feedback,
    PersonalReport,
    ActivityDescription,
    OrganiserIntroduction,
    VideoPlay,
  },
  data () {
    return {
      isActive:true,
      activitiesHome: true,
      enterMission: false,
      enterInfo: false,
      enterConsult: false,
      enterBBS: false,
      enterTreasure:false,
      enterReport:false,
      enterAward:false,
      enterActivityNotice:false,
      enterChat:false,
      enterVideo:false,
      myAward:'',
      enterMissionId: 0,
      bulletList: [],
			missionNames : ['疯狂动物城','生涯罗盘','大学生ToDoList',
			'职业倾向测评','职业世界探索','职业倾向匹配',
			'优秀大学生图鉴','职业能力知多少','目标职位能力大赏',
			'决策风格测评','毕业政策探索','我的决策产生记',
			'生涯扫雷','多宝库'],
      firstTime:false,
      videoWidth: document.documentElement.clientWidth,
      videoHeight: document.documentElement.clientHeight,
      cannotplay: false,
      cannotplayInfo: "",
      arrFirstIdPerZone: [1,2,4,7,8,10,11,13],  //这些关卡，不需要前置关卡
      enterActivityDescription: false,
      enterOrganiserIntroduction: false,
      outLogin: false, //确定要退出吗
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
      arrCosPlay: state => state.shengyaUser.arrCosPlay,
      arrCosAward: state => state.shengyaUser.arrCosAward,
			isSDKReady: state => state.user.isSDKReady,
			userInfo: state => state.user.userInfo,
			chatInfo: state => state.conversation.chatInfo,
			userID: state => state.conversation.chatInfo.userId,
    }),
    jsonSetting() {
      return JSON.parse(this.shengyaUser.admin.jsonSetting);
    },
    dayi() {
      return this.jsonSetting && this.jsonSetting.guanzhu==1? true : false;
    },
    openAward() {
      return this.jsonSetting && this.jsonSetting.award==1? true : false;
    },
    consult() {
      return this.jsonSetting && this.jsonSetting.consult==1? true : false;
    },
     //是否显示专家咨询
    isShowConsult() {
      return this.jsonSetting &&(this.jsonSetting.isShowConsult == undefined || this.jsonSetting.isShowConsult==1)  ? true : false;
    },
   //是否现在在线支持
    isShowSupport() {
      return this.jsonSetting && (this.jsonSetting.isShowSupport == undefined || this.jsonSetting.isShowSupport==1) ? true : false;
    },
     //是否显示取消按钮
    isShowExit() {
      return this.jsonSetting && (this.jsonSetting.isShowExit !== undefined || this.jsonSetting.isShowExit == 1) ? true : false;
    },

    allowMissionIds() {
      return this.jsonSetting && this.jsonSetting.missionId? this.jsonSetting.missionId.split(","):null;
    },
    title(){
      return this.jsonSetting.title?this.jsonSetting.title:"生涯驿站-活动广场";
    },
    notBegin() {
      let startDate = this.shengyaUser.admin.startDate
      let diffStartDate = moment(startDate).diff(moment().format(), 'days')
      return diffStartDate>0;
    },
    alreadyEnd() {
      let endDate = this.shengyaUser.admin.endDate
      let diffEndDate = moment(endDate).diff(moment().format(), 'days')
      return diffEndDate<0;
    },
		partnerCode() {
  		return this.shengyaUser.admin.manageAccCode.replace('admin','')
		},
    currentSplashSrc() {
      return 'http://sys.rennengda.com/weekon/cos/images/splash-' + this.partnerCode + '.jpg'
    },
		currentFaceSrc() {
      return 'http://sys.rennengda.com/weekon/cos/images/face-' + this.partnerCode + '.jpg?'+ Date.now()
		},
    currentVideoSrc() {
      return 'https://video-1251246987.cos.ap-shanghai.myqcloud.com/cos/' + this.partnerCode + '-video.mp4'
    },
		currentVideoFaceSrc() {
      return 'https://video-1251246987.cos.ap-shanghai.myqcloud.com/cos/' + this.partnerCode + '-face.jpg'
		},
		timUserId() {
			return 'user'+ this.shengyaUser.userId
		},

		nickname() {
			return this.shengyaUser.studentCollege + this.shengyaUser.studentName
		},
    partnerCode() {
    	return this.shengyaUser.admin.manageAccCode.replace('admin','')
    },
    logoImg(){
      return "http://sys.rennengda.com/public/images/logo_01.png"
    },
  },
  created(){
    setWechatTitle(this.title);
    // this.getAllBullet()
    this.setTimes()
  },
	beforeMount() {
    // console.log('开始 activities beforeMount() 初始化监听器')
    this.$bus.$on('back-activities', this.handleBackActivities)
	},
	mounted() {
    console.log(this.jsonSetting.isShowConsult,'this.jsonSetting.isShowConsult')
    // console.log('开始 activities mounted() 登录tim')
    this.initEnterInfo()
    history.pushState(null, null, document.URL)
    window.addEventListener('popstate', this.forbidback);
	},
  beforeDestroy () {
    window.removeEventListener('popstate',this.forbidback);
  },
  methods : {
    iconImg(name){
      return "http://sys.rennengda.com/public/images/icon/"+name+".gif"
    },
    forbidback(){
      //回退按钮点击处理
      let state = {
        title: 'title',
        url: "#"
      }
      window.history.pushState(state, state.title, state.url)
      window.addEventListener("popstate", function (e) {
        location.href = '/cos/'
      }, false);
    },
    //初始化判断是否要进入个人资料
    initEnterInfo () {
      if (this.shengyaUser.operator == null || this.shengyaUser.studentCollege == null
        || this.shengyaUser.operator.admin.manageAccCode!=this.shengyaUser.admin.manageAccCode) {
        this.activitiesHome = false
        this.enterInfo = true
      }
    },
    checkMissionInvalid(missionId) {
      let validStep1 = false, validStep2 = false ;  //默认不能用
      //先检查后台设定
      if(this.allowMissionIds) {  //有设定
        if(this.allowMissionIds.indexOf(missionId+"")>-1) {  //设定中有该关次
          validStep1 = true;
        }
      }
      else{   //没有设定，默认都可以
          validStep1 = true;
      }
      //再检查前置关卡情况
      if(this.arrFirstIdPerZone.indexOf(missionId)>-1)   //该关卡不需要前置关卡
        validStep2 = true;
      else if(this.arrCosPlay[missionId-2]==1)    //前置关卡已做完
        validStep2 = true;
      //返回
      let valid = validStep1 && validStep2;
      return !valid;
    },
    // 进入答疑
    handleEnterChat() {
      let user = this.shengyaUser
      window.open(
        'https://www.yingyuchat.com/chatIndex?kefu_id=rnd500&ent_id=5083&lang=cn'
        + '&visitor_id=' + user.openid + '&visitor_name='
        + user.studentUniversity + '-'
        + user.studentCollege + '-'
        + user.studentMajor + '-'
        + user.studentDegree + '-'
        + user.studentNo + '-'
        + user.studentName
        + '&avator=&extra='
      )
      // if(this.dayi){
      //   this.activitiesHome = false
      //   this.enterChat = true
      // }
    },
    //进入个人资料
    handleEnterInfo () {
      this.activitiesHome = false
      this.enterInfo = true
    },
    //进入闯关
    handlePlayMission (missionId) {
      if(this.notBegin){
        this.cannotplay = true;
        this.cannotplayInfo =  "活动还未开始";
      }
      else if (this.alreadyEnd){
        this.cannotplay = true;
        this.cannotplayInfo =  "活动已经结束";
      }
      else{
        this.activitiesHome = false
        this.enterMission = true
        this.enterChat = false
        this.enterMissionId = missionId
      }
    },
    //进入咨询
    handleEnterConsult () {
      if(this.consult){
        let n=0
        this.shengyaUser.arrCosPlay.map((item,index)=>{
          if(parseInt(item)){
            n++
          }
        })
        if(n>=5){
          this.activitiesHome = false
          this.enterConsult = true
        }else{
          this.cannotplay = true;
          this.cannotplayInfo =  "完成5关及以上，可以进行在线咨询";
        }
      }
    },
    finishUser(){
      this.enterInfo = false;
      if(this.jsonSetting.video==1)
        this.enterVideo = true;
      else
        this.handleBackActivities();
    },
    ignoreVideo(){
      this.enterVideo = false;
      this.handleBackActivities();
    },
    //从关卡返回活动广场
    handleBackActivities() {
      //加入活动广场群组
      // console.log("活动广场")
      setWechatTitle(this.title);
      this.activitiesHome = true
      this.enterMission = false
      this.enterInfo = false
      this.enterConsult = false
      this.enterBBS = false
      this.enterChat = false
      this.enterTreasure = false
      this.enterAward = false
      this.enterReport = false
      this.enterActivityNotice = false
      this.enterOrganiserIntroduction = false
      this.enterActivityDescription = false
    },
    // 进入多宝库
    handleEnterTreasure(){
      this.activitiesHome = false
      this.enterTreasure = true
    },
    // 进入抽奖页
    handleEnterAward(){
      if(this.openAward){
        let n=0,status = false
        this.shengyaUser.arrCosPlay.map((item,index)=>{
          if(parseInt(item)){
            n++
          }
        })
        if(parseInt(this.shengyaUser.arrCosPlay[12])){
          status=true
        }
        if(n>=5&&status){
          this.activitiesHome = false
          this.enterAward = true
        }else{
          this.cannotplay = true;
          this.cannotplayInfo =  "至少完成5关，且必须完成第13关'生涯扫雷'才能参与抽奖";
        }
      }
    },
    // 进入个人报告
    handleEnterReport(){
      this.activitiesHome = false
      this.enterReport = true
    },
    enterActivity(){
      this.firstTime = false
    },
    // 进入活动介绍
    handleEnterActivityDescription(){
      this.activitiesHome = false
      this.enterActivityDescription = true
    },
    // 进入主办方介绍
    handleEnterOrganiserIntroduction(){
      this.activitiesHome = false
      this.enterOrganiserIntroduction = true
    },
    setTimes(){
      // localStorage.removeItem('startTime')
      let now = moment(new Date()).format("YYYY-MM-DD")
      let n = localStorage.getItem('startTime')
      if(this.jsonSetting && this.jsonSetting.isShowSplash == 1 && this.jsonSetting.isShowSplash !== undefined) {
        if(!n){
        n=no
        this.firstTime = true
      }else{
        const diff1 = moment(now).diff(moment(n), 'days')
        if(diff1>0){
          n = now
          this.firstTime = true
        }
      }
      } else {
        this.firstTime = false
      }
      localStorage.setItem('startTime', n)
    },
    //退出
    sureOutLogin() {
      this.outLogin = false
      sessionStorage.clear();
      window.location.replace(`http://wx.rennengda.com/cos/scanningLogin?p=${this.partnerCode}`)
      // this.$router.replace({
      //   path: '/scanningLogin',
      //   query: { accode: partnerCode } 
      // });

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
 .home-img
  width:100%
.first-bg
  position: relative;
  img
    width:100%
.active
  font-size:0.32rem
  color:#DC6E5A

.text-info
  overflow:hidden
  padding:0.2rem
  .text-left
    float:left
  .text-right
    float:right
    font-size:0.24rem
	  span
	    color:#DC6E5A
  .info
    float:right
    background-color : transparent
  .color 
    color: #206EC1
/*滚动文字的样式*/
.text-container
  height: 30px
  line-height: 30px
  margin: 0.1rem auto
  overflow: hidden
.area
  background: #ffffff
  padding:0.16rem
  margin-top:0.16rem

.area-title
  text-align:center
  margin-top:0.1rem
  font-size:0.28rem
  margin-bottom:0.2rem

.area-content
  overflow:hidden

.left-side,.right-side
  background-color:#D5F1FC
  width:49%
  border-radius:0.08rem
.left-side
  float:left
  position:relative
.right-side
  float:right
.left-module
  background-color:#ffffff
  margin:0.2rem 0 0 0
 .left-module:nth-child(odd)
  margin-right:0.1rem

.left-consult,.right-consult
  background-color:#D0D5E8
  width:49%
  border-radius:0.08rem
  .gray
    color:#777777
  .countInfo
    color:#DC6E5A
.left-consult
  float:left
  position:relative
.right-consult
  float:right

.area-box
  background-color:#D5F1FC
  margin:0.2rem 0.1rem
  overflow:hidden
  border-radius:0.24rem
  .countInfo
    color:#DC6E5A
.img-area
  float:left
  margin:0.1rem 0.1rem

.img-area
  .icon-ketangdayi
    color:#dc6e5a
    font-size:0.8rem
    line-height:0.84rem
  img
    width:0.84rem
    height:0.84rem
.text-area
    float:left
    font-size:0.24rem;
    h4
        font-size:0.28rem
        margin-top: 0.2rem
    .text-name
        margin-top:0.3rem
        font-size:0.32rem
    .text-sp
      margin-top: 0.4rem
      font-size:0.28rem
      .emphasize
        color:#dc6e5a
.text
  margin: 0
  float:left
  background:#787878
  color:#ffffff
  padding:0 10px
  border-radius:10px
  margin-right:20px

.inner-container
    width:500%
    animation: myMove 20s linear infinite
    animation-fill-mode: forwards
    @keyframes myMove
      0%
        transform translateX(0)
      100%
        transform translateX(-1300px)

.invalid
  filter:Gray
  -webkit-filter: grayscale(100%)
  .disabled
   position:absolute
   top:0.2rem
   left:1rem
   color:#777777
   transform:rotate(45deg)
   z-index:10
   opacity:0.7
   i
     font-size:1.2rem
.bottom
  margin:0.2rem
  text-align :center
  img
    width:1.64remdialog-footer
    height:0.54rem
  span
    margin-left : 0.2rem
.footerBtn {
  display:flex
  justify-content:space-between
}
</style>
